import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { push } from 'connected-react-router';

// Components
import { App } from '../../../App';
import { FullScreenLoader } from '../../../components/Loaders/FullScreenLoader';
import { RevisionSelector } from '../../../components/Publishing/RevisionSelector';

// Styles
import { SmartContainer, Surface } from '../../../styles/Containers'

// Redux
import { FullPeople } from './redux/people.selectors';
import { getPerson } from './redux/people.actions';
import { AssetsList } from '../Assets/AssetsList';
import { hasAccess, useActiveItem } from '../../services/CaptureCollabService';
import { StyledIconButton } from '../../../styles/matieralui/IconButton';
import { IconSettings } from '../../Icons';
import { StyledFullScreenModal } from '../../components/Content/FullScreenModal';
import { AssetViewer } from '../Assets/AssetViewer';


export const PersonPage = () => {

    // New Modal
    const dispatch = useDispatch();
    const store = FullPeople();
    const { id } = useParams();
    const [openViewer, setOpenViewer] = useState(false);
    const [activeAsset, setActiveAsset] = useState(null);
    const [filters, setFilters] = useState(null);
    const { activeItem, setActiveItem } = useActiveItem({ id, model: 'Person', selector: FullPeople, getAction: getPerson })


    // --------------------------
    // Effects
    // --------------------------

    // Get This Item
    useEffect(() => {
        // Set The Filters
        const args = { Person: `["${id}"]` }
        setFilters(args);
    }, [id]);


    // --------------------------
    // Interactions
    // --------------------------

    const handleRevisionChange = (revision) => {

        // Clear Revision
        if (!revision) setActiveItem(activeItem);
        else {

            const mergedData = { ...revision.fields, id: revision.modelId }
            setActiveItem(mergedData);
        }
    }

    const handleSelect = (item) => {
        dispatch(push(`/asset/${item.id}`))
        // setActiveAsset(item);
        // setOpenViewer(true);
    }

    const renderTopBarChildren = () => {

        return (
            <SmartContainer flex align="center" justify="flex-end">
                {id && (<StyledIconButton onClick={() => dispatch(push(`/people/${id}/settings`))}><IconSettings /></StyledIconButton>)}
            </SmartContainer>
        )

    }
    // --------------------------
    // Renders
    // --------------------------

    // Add Revisions
    const sideBarChildren = () => (
        <Surface>
            <RevisionSelector
                label="Revisions"
                item={activeItem}
                model="ExampleContent"
                modelId={activeItem?.id}
                selector={FullPeople}
                action={getPerson}
                onChange={handleRevisionChange}
            />
        </Surface>
    )


    // Render Page
    const personsName = (activeItem?.name) ? activeItem?.name : 'Loading';

    return (
        <App title={personsName}
            topBarChildren={renderTopBarChildren()}
            breadcrumbs={[{ href: `/people`, title: 'People' }]}
        >
            {!activeItem && (<FullScreenLoader />)}
            {activeItem && (
                <SmartContainer width="100%">
                    {filters && (<AssetsList onSelect={handleSelect} filters={filters} lockFilters={true} sortByKey={`${id}SortPerson`} filterByDateKey={`${id}FilterDatePerson`} filterByTypeKey={`${id}FilterTypePerson`} />)}
                    <StyledFullScreenModal open={openViewer} onClose={() => setOpenViewer(false)} fullWidth>
                        <AssetViewer onClose={() => setOpenViewer(false)} asset={activeAsset} />
                    </StyledFullScreenModal>
                </SmartContainer>
            )}
        </App>
    )
}